module.exports = __webpack_public_path__ + "assets/img_etsy.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_etsy.jpg
 ** module id = 122
 ** module chunks = 1
 **/